<template>

<div class="section">

	<com-headmain :simple="true" />

	<div class="section-content">

		<div class="section-exit" v-if="!window.is.mobile" v-on:click="onExitClick">Home</div>
		<div class="section-back" v-if="!first && !window.is.mobile && !$isPatient" v-on:click="onBackClick">&larr; Back</div>

		<portal to="modal">
			<com-intro v-if="!$isPatient && intro && !$_.contains(is.introClosed, intro)" :text="intro" v-on:close="onIntroClose" />
		</portal>

		<com-head :section="section" />

		<com-form :section="section" v-if="!currentAlert && (isProfiling || $isPatient)" />

		<template v-for="alert in alerts">

			<com-alert :alert="alert" :key="alert.id" v-if="alert.id === currentAlert" />

		</template>

		<com-alert :alert="dynamicAlert" v-if="currentAlert === true" />

		<slot></slot>

		<com-foot :section="section" :back="back" v-if="!currentAlert && (!isAiding || $isPatient) && !window.is.mobile && !hideFoot" v-on:next="$emit('next')" v-on:back="$emit('back')" />

	</div>
	
</div>

</template>

<script>

import comHeadMain from './../../common/Head'
import comHead from './section/Head'
import comForm from './section/Form'
import comFoot from './section/Foot'
import comAlert from './section/Alert'
import comIntro from './section/Intro'

export default {

	props: ['section', 'intro', 'first', 'hideFoot', 'back'],

	components: {

		'com-headmain': comHeadMain,
		'com-head': comHead,
		'com-form': comForm,
		'com-foot': comFoot,
		'com-alert': comAlert,
		'com-intro': comIntro

	},

	data: function() {

		return {
			is: {
				introClosed: []
			}
		}

	},

	watch: {

		intro: function(n) {

			if (n && !this.$isPatient && !this.$_.contains(this.is.introClosed, n)) {

				this.$emit('introducing')

			}

		}

	},
	
	created: function() {

		if (this.intro && !this.$isPatient) this.$emit('introducing')

	},

	computed: {

		dynamicAlert: function() {

			return this.$store.getters['session/alerts/dynamic']

		}

	},

	methods: {

		onExitClick: function() {

			//window.location.reload()
			this.$router.push({
				name: 'Home'
			})

		},

		onBackClick: function() {

			this.$emit('back')

		},

		onIntroClose: function() {

			this.is.introClosed.push(this.intro)
			this.$emit('introduced')

		}

	}

}

</script>

<style scoped>

.section {
	position: absolute;
	left: 300px;
	right: 0px;
	top: 0px;
	height: 100%;
	z-index: 1;
	overflow-y: auto;
}

@media print {

	.section {
		left: auto;
		position: relative;
		right: auto;
		height: auto;
	}

}

.section-back {
	position: absolute;
	left: 25px;
	top: 20px;
	height: 48px;
	line-height: 48px;
	color: #343434;
    font-size: 20px;
	cursor: pointer;
	z-index: 1000;
	font-weight: 400;
}

.section-exit {
	position: absolute;
	right: 25px;
	top: 20px;
	width: 48px;
	height: 48px;
	cursor: pointer;
	line-height: 110px;
	background-image: url(~@/assets/exit.svg);
	background-position: 50% 50%;
	background-repeat: no-repeat;
	z-index: 1000;
}

.is-mobile .section-exit {
	right: 5px;
	top: 5px;
}

.is-tablet .section {
	left: 64px;
}

.is-mobile .section {
	left: 0px;
	padding-left: 0px;
}

.section-content {
	width: 100%;
	max-width: 1200px;
	padding: 90px;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}

@media print {

	.section-exit,
	.section-back {
		display: none;
	}

	.section-content {
		max-width: 100%;
		padding: 0px;
		min-height: auto;
	}

}

.is-tablet .section-content {
	width: 100%;
}

.is-mobile .section-content {
	width: 100%;
	padding: 80px 15px 85px 15px;
}

.is-mobile .is-dark .section-content {
	padding: 15px;
}

</style>